import { Actions } from "../table/table.actions"
import createTableReducer, { DEFAULT_STATE } from "../table/table.reducer"

const INITIAL_STATE = {
  ...DEFAULT_STATE,
  defaultSorting: ["full_name=asc", "status=asc"],
  sorting: ["full_name=asc"],
}

const usersTableReducer = (state = INITIAL_STATE, action: Actions) =>
  createTableReducer("USERS_TABLE", {})(state, action)

export default usersTableReducer
